import { IonIcon } from '@ionic/react';
import {
  calendarOutline,
  cardOutline,
  checkmarkOutline,
  copyOutline,
  lockClosedOutline,
} from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

import { SectionStyles } from './PaymentDescription.styles';

export const PaymentDescription: React.FC = () => {
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    }
  }, [isCopied]);

  const handleCopyTestCard = () => {
    navigator.clipboard.writeText('4242 4242 4242 4242');
    setIsCopied(true);
  };

  return (
    <SectionStyles>
      <OnboardingTitle>Payment details</OnboardingTitle>

      <UiTypography
        variant="body-medium"
        align="center"
        className="description"
      >
        <IonIcon icon={cardOutline} />
        Default test card: 4242 4242 4242 4242
        <IonIcon
          icon={isCopied ? checkmarkOutline : copyOutline}
          onClick={handleCopyTestCard}
          className="copy-icon"
        />
      </UiTypography>

      <UiTypography
        variant="body-medium"
        align="center"
        className="description"
      >
        <IonIcon icon={calendarOutline} />
        Expiration date should be in the future.
      </UiTypography>

      <UiTypography
        variant="body-medium"
        align="center"
        className="description"
      >
        <IonIcon icon={lockClosedOutline} />
        CVV - any 3 digits.
      </UiTypography>

      <UiTypography variant="body-small" color="neutral-black">
        If you need specific card, use the following link -{' '}
        <a href="https://docs.stripe.com/testing?locale=en-GB" target="_blank">
          https://docs.stripe.com/testing?locale=en-GB
        </a>
      </UiTypography>
    </SectionStyles>
  );
};
